
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insights/[entry]",
      function () {
        return require("private-next-pages/insights/[entry].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insights/[entry]"])
      });
    }
  